import { DraftUncategorizedLeg } from '#/unified-rfqs/ui/rfq-builder/types';
import { NEGATIVE_SIGN } from '@paradigm/utils/src/enhanceNegativeSign';
import { uncategorizedProductView } from './leg-product';

export function uncategorizedLegView(
  leg: DraftUncategorizedLeg,
  selectedVenue: string,
  isRemovable: boolean,
  isOrderBook: boolean,
) {
  return {
    index: leg.index,
    kind: undefined,
    isValid: false as const,
    product: uncategorizedProductView(selectedVenue, isOrderBook),
    isRemovable,
    greeks: undefined,
    isHedge: false,
    quantity: {
      value: undefined,
      isValid: false,
      isVisible: !isOrderBook,
      isDisabled: false,
      contractQuantity: NEGATIVE_SIGN,
    },
  };
}
